export const darkGrey = '#434343'
export const primaryColor = '#F8A11E'
export const primaryColorDark = '#C98405'
export const lightGrey = '#e5e5e5'
export const larkYellow = '#f6a01e'
export const mediumGrey = '#686868'



// WEBPACK FOOTER //
// ./src/colors.js